import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "font-semibold text-2xl text-black sf-pro" }
const _hoisted_2 = { class: "flex flex-col gap-2 sf-pro" }
const _hoisted_3 = { class: "text-lg font-medium leading-[20px] text-brown whitespace-pre-line mb-2" }

import ModalComponent from "@/components/ModalComponent.vue";
import { ref } from "vue";
import { useI18n } from "vue-i18n";
import GradientButton from "@/components/buttons/GradientButton.vue";
import { useRouter } from "vue-router";
import { ROUTE_NAMES } from "@/constants/routeNames";
import { PREMIUM_CALCULATORS } from "@/types/premiumTypes";
import { fetchStripeDestinyMatrixProductUrl } from "@/api/subscription";
import { useUserStore } from "@/stores/userStore";


export default /*@__PURE__*/_defineComponent({
  __name: 'RequirePremiumModal',
  props: {
    show: { type: Boolean },
    selectedDate: {}
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emits = __emit;

const { t } = useI18n();
const router = useRouter();
const authStore = useUserStore();

const waitApiCall = ref(false);

function openSubscribePage() {
  const query = { openCalculator: PREMIUM_CALCULATORS.destinyMatrix };

  router.push({ name: ROUTE_NAMES.USER, query: query });
}

async function openStripePurchasePage() {
  if (authStore.user === null) {
    return router.push({ name: ROUTE_NAMES.USER });
  }
  try {
    waitApiCall.value = true;
    const apiDate = props.selectedDate.split(".").reverse().join("-");
    const stripeUrl = await fetchStripeDestinyMatrixProductUrl(apiDate);

    if (stripeUrl) {
      window.location.href = stripeUrl;
    }
  } catch (e) {
    console.error(e);
  } finally {
    waitApiCall.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalComponent, {
    show: __props.show,
    onClose: _cache[0] || (_cache[0] = ($event: any) => (emits('close'))),
    containerClass: "bg-white !max-w-md"
  }, {
    header: _withCtx(() => [
      _createElementVNode("p", _hoisted_1, _toDisplayString(_unref(t)("calculators.destiny-matrix.premium-modal.title")), 1)
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(t)("calculators.destiny-matrix.premium-modal.body", {
              date: __props.selectedDate,
            })), 1),
        _createVNode(GradientButton, {
          class: "h-[46px] md:h-14",
          "bg-color": "bg-brown-gradient",
          "hover-bg-color": "bg-orange-gradient",
          text: 
            _unref(t)('calculators.destiny-matrix.premium-modal.buy-subscribe-btn')
          ,
          onClick: openSubscribePage
        }, null, 8, ["text"]),
        _createVNode(GradientButton, {
          class: "h-[46px] md:h-14",
          "bg-color": "bg-brown-gradient",
          "hover-bg-color": "bg-orange-gradient",
          text: 
            _unref(t)('calculators.destiny-matrix.premium-modal.buy-date-btn', {
              date: __props.selectedDate,
            })
          ,
          isDisabled: waitApiCall.value,
          isLoading: waitApiCall.value,
          onClick: openStripePurchasePage
        }, null, 8, ["text", "isDisabled", "isLoading"])
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})